module.exports = __webpack_public_path__ + "static/media/microscopy-nsit0108-01 6.c8a670ae.png";